import React from "react";
import { ReportBase } from "#root/components/ReportBase";

const StatusReport: React.FC = () => {
    return (
        <ReportBase 
            pageTitle="Status Report"
            settingsButtonText="Status Report Settings"
            settingsDialogTitle="Status Report Settings"
            className="status-report-page"
        />
    );
};

export default StatusReport;
